import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./app/dashboard";
import { BoletoLista } from "./app/dashboard/adimplencias/boletos";
import { Contratantes } from "./app/dashboard/adimplencias/contratantes";
import Importacao from "./app/dashboard/adimplencias/importacoes";
import AdimplenciasLayout from "./app/dashboard/adimplencias/layout";
import PainelAdimplencia from "./app/dashboard/adimplencias/painel";
import Parametros from "./app/dashboard/adimplencias/parametros";
import Estatisticas from "./app/dashboard/estatisticas";
import { AddNegotiation } from "./app/dashboard/inadimplencias/gerar";
import ImportacoesInadimplencias from "./app/dashboard/inadimplencias/importacao";
import { ListagemCobrancas } from "./app/dashboard/inadimplencias/listagem";
import DashboardLayout from "./app/dashboard/layout";
import NegotiateProvider from "./app/dashboard/negociar";
import Propostas from "./app/dashboard/propostas";
import BoletosAVencer from "./app/dashboard/relatorios/boletosAVencer";
import Relatorios from "./app/dashboard/relatorios/gerais";
import { RelatorioGerencial } from "./app/dashboard/relatorios/gerencial";
import RelatorioNegociacoes from "./app/dashboard/relatorios/negociacoes";
import RelatorioComnNegociados from "./app/dashboard/relatorios/negociadosComunicados";
import { NegociadosHigienizados } from "./app/dashboard/relatorios/negociadosHigienizados";
import { LogsystemPage } from "./app/dashboard/relatorios/registroAcoes";
import Configuracoes from "./app/dashboard/topbar/configuracao";
import Endereco from "./app/dashboard/topbar/endereco";
import { Perfil } from "./app/dashboard/topbar/perfil";
import Tutoriais from "./app/dashboard/tutoriais";
import Associates from "./app/dashboard/usuarios";
import App from './app/index';
import Login from "./app/login";
import PageNotFound from "./app/not_found";
import Redirecionamento from "./app/redirecionamento";
import ResetSenha from "./app/resetsenha";
import SignupLayout from "./app/signup/layout";
import CadastroStateCheck from "./app/signup/passo0";
import FirstContact from "./app/signup/passo1";
import CadastroRepresentante from "./app/signup/passo2";
import ZoopCadastro from "./app/signup/passo3";
import AuthRoute from "./routes/authRoute";
import RedirectRoute from "./routes/redirectRoute";
import RedirectSignUpRoute from "./routes/redirectSignUpRoute";
import { SignUpRoute } from "./routes/signUpRoute";
import { SignUpRouteDefault } from "./routes/signUpRouteDefault";
import { ZoopRoute } from "./routes/zoopRoute";
import ListagemInadimplentes from "./app/dashboard/inadimplencias/inadimplentes";

function RoutesIndex() {
  //const {mostrarFooter} = useGeneral()
  return (
    <Routes>
      <Route path="/" element={<App/>} />
      <Route path="login" element={
        <RedirectRoute redirectTo='/dashboard'>
          <Login/>
        </RedirectRoute>
      } />
      <Route path="resetsenha" element={<ResetSenha/>} />
      <Route path="cadastro_link/:redirecionamento_id" element={<Redirecionamento/>} />
      <Route path="cadastro/passo0" element={<Navigate to="/cadastro"/>} />
      <Route path='cadastro' element={
          <SignupLayout/>
      } >
        <Route index element={
          <RedirectSignUpRoute>
            <CadastroStateCheck/>
          </RedirectSignUpRoute>
        }/>
        <Route path='passo1' element={
          <SignUpRouteDefault>
            <FirstContact/>
          </SignUpRouteDefault>
        }/>
        <Route path='passo2' element={
          <SignUpRoute>
            <CadastroRepresentante/>
          </SignUpRoute>
        }/>
        <Route path='passo3' element={
          <ZoopRoute>
            <ZoopCadastro/>
          </ZoopRoute>
        }/>
      </Route>
      <Route path="dashboard" element={
        <AuthRoute redirectTo='/login'>
          <DashboardLayout />
        </AuthRoute>
      }>
        <Route index element={<Home />} />
        <Route path="configuracoes" element={<Configuracoes />} />
        <Route path="endereco" element={<Endereco/>}/>
        <Route path="perfil" element={<Perfil/>}/>
        <Route path="estatisticas" element={<Estatisticas />} />
        <Route path="gerar" element={<AddNegotiation />} />
        <Route path="inadimplentes" element={<ImportacoesInadimplencias />} />
        <Route path="negociacoes" element={<ListagemCobrancas/>} />
        <Route path="inadimplenteslistagem" element={<ListagemInadimplentes/>} />
        <Route path="adimplencia" element={<AdimplenciasLayout />}>
          <Route path="" element={<PainelAdimplencia />}/>
          <Route path="parametros" element={<Parametros/>}/>
          <Route path="importar" element={<Importacao/>}/>
          <Route path="clientes" element={<Contratantes/>}/>
          <Route path="boletos" element={<BoletoLista/>} />
        </Route>
        <Route path="relatorio/:type" element={<Relatorios/>} />
        <Route path="relatoriogerencial" element={<RelatorioGerencial/>}/>
        <Route path="boletosavencer" element={<BoletosAVencer/>}/>
        <Route path="relatorionegociacoes" element={<RelatorioNegociacoes/>}/>
        <Route path="relatorioComnNegociados" element={<RelatorioComnNegociados/>}/>
        <Route path="higienizados" element={<NegociadosHigienizados/>}/>
        <Route path="relatorioAcoes" element={<LogsystemPage/>}/>
        <Route path="negociar" element={<NegotiateProvider/>}/>
        <Route path="propostas" element={<Propostas/>} />
        <Route path="usuarios" element={<Associates/>}/>
        <Route path="estatisticas" element={<Estatisticas/>}/>
        <Route path="tutoriais" element={<Tutoriais/>}/>
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  )
}

export default RoutesIndex